export class LocationPin {
  id: number;
  lat: number;
  long: number;
  primary: boolean;
  description: string;

  // Google Map Marker
  marker?: any;
}
